module.exports = __webpack_public_path__ + "img/30.8fcd31f3.svg";